import { axios as service } from '../axiosService';
import { BASE_URL } from './index';
import { QUES_SECTIONS_SEQ } from '@model/questionmaires/questionnaire';
import { getSGAData } from './analysis.api';
// import { delay } from '@utils';

export const getQuestionCollectionRequest = ({
  projectId,
  sequence,
  queryType = '',
}) => {
  if (!projectId) {
    return;
  }

  return service.get(
    `${BASE_URL}/project/questionnaire/${projectId}${
      Number(sequence) > -1 ? `/${sequence}` : ''
    }${queryType ? `?queryType=${queryType}` : ''}`,
  );
};

export const postQuestionnaireAccess = (obj, projectId) =>
  service.post(
    `${BASE_URL}/project/questionnaireSection/saveSectionOptOutStatusInfo/${projectId}`,
    obj,
  );

export const getQuestionnaireAccess = (projectId) =>
  service.get(
    `${BASE_URL}/project/questionnaireSection/getSectionOptOutStatusInfo/${projectId}`,
  );

export const unhideQuestionnaireForInternalUser = (projectId) =>
  service.get(
    `${BASE_URL}/project/unhideQuestionnaireForInternalUser/${projectId}`,
  );

export const submitQuestionAnswerRequest = ({
  sequence,
  answer,
  projectId,
}) => {
  if (!projectId) {
    return undefined;
  }

  return service.post(
    `${BASE_URL}/project/questionnaire/${projectId}/${sequence}`,
    {
      answer,
    },
  );
};

export const getReviewResponses = (projectId) =>
  service.get(`${BASE_URL}/project/questionnaireAnswer/${projectId}`);

export const submitReviewResponses = (projectId) =>
  service.get(
    `${BASE_URL}/project/questionnaireScore/calculateScore/${projectId}`,
  );

export const getComplexityBySectionRequest = async ({
  projectId,
  section,
  isManualMode: isManual,
}) => {
  // const API_MAP = {
  //   // overall: 'getOverallComplexity',
  //   strategy: 'getSectionComplexity',
  //   value: 'getSectionComplexity',
  //   enterprise: 'getSectionComplexity',
  //   people: 'getSectionComplexity',
  //   execution: 'getSectionComplexity',
  // };
  const sectionIndex =
    QUES_SECTIONS_SEQ.findIndex((itm, idx) => itm === section) + 1;

  // const api = API_MAP[section];

  if (section === 'value') {
    const resDataRaw = await Promise.all([
      service.get(
        `${BASE_URL}/project/questionnaireComplexity/getSectionComplexity${
          isManual ? 'ForManualView' : ''
        }/${projectId}/${sectionIndex}`,
      ),
      getSGAData(projectId),
    ]);
    const res = { ...resDataRaw[0], sgaData: resDataRaw[1] };
    return res;
  }
  if (section !== 'overall') {
    return service.get(
      `${BASE_URL}/project/questionnaireComplexity/getSectionComplexity${
        isManual ? 'ForManualView' : ''
      }/${projectId}/${sectionIndex}`,
    );
  }
  return service.get(
    `${BASE_URL}/project/questionnaireComplexity/getOverallComplexity${
      isManual ? 'ForManualView' : ''
    }/${projectId}`,
  );

  //
  // return service.get(
  //   `${BASE_URL}/project/questionnaireComplexity/${api}${
  //     isManual ? 'ForManualView' : ''
  //   }/${projectId}`,
  // );
};

export const postComplexityBySectionRequest = ({
  projectId,
  section,
  reqData,
  isManual,
}) => {
  const sectionIndex =
    QUES_SECTIONS_SEQ.findIndex((itm, idx) => itm === section) + 1;
  if (!projectId) {
    return undefined;
  }
  // debugger;
  return service.post(
    `${BASE_URL}/project/questionnaireComplexity/saveSectionComplexity${
      isManual ? 'ForManualView' : ''
    }/${projectId}/${sectionIndex}`,
    reqData,
  );
};

export const postRiskRequest = ({ projectId, section, reqData, isManual }) =>
  service.post(
    `${BASE_URL}/project/questionnaireComplexity/saveRiskMitigation${
      isManual ? 'ForManualView' : ''
    }/${projectId}`,
    reqData,
  );

export const submitOverallComplexityTextRequest = ({
  projectId,
  postBody = {},
  isManual,
}) => {
  if (!projectId) {
    return undefined;
  }

  return service.post(
    `${BASE_URL}/project/questionnaireComplexity/saveOverallComplexity${
      isManual ? 'ForManualView' : ''
    }/${projectId}`,
    postBody,
  );
};

export const getComplexitySiderDataRequest = async (projectId) => {
  const response = await service.get(
    `${BASE_URL}/project/questionnaireComplexity/getDealComplexitySideBarInfo/${projectId}`,
  );

  try {
    const result = {};
    const overall = response.overallComplexity;
    if (overall) {
      result.overall = {
        level: overall.level,
        levelPercent: overall.levelPercent ? overall.levelPercent * 100 : 0,
      };
    }
    for (const { name, level, levelPercent } of response.sectionComplexity) {
      if (!level) {
        break;
      } else {
        result[name.toLowerCase()] = {
          levelPercent: levelPercent ? levelPercent * 100 : 0,
          level,
        };
      }
    }
    return { ...result, abled: Object.keys(result).length > 0 };
  } catch (error) {
    return {
      abled: false,
    };
  }
};

export const getPDFCustomizationSettings = async (projectId) => {
  const response = await service.get(
    `${BASE_URL}/project/project-misc-config/${projectId}?about=customize-pdf-report`,
  );

  return response;
};

export const savePDFCustomizationSettings = async (projectId, settings) => {
  const response = await service.post(
    `${BASE_URL}/project/project-misc-config/${projectId}?about=customize-pdf-report`,
    settings,
  );
  return response;
};
export const resetSection = (projectId, sectionSeq) =>
  service.get(
    `${BASE_URL}/project/questionnaire/resetSection/${projectId}/${sectionSeq}`,
  );

export const resetQuestionnaire = (projectId) =>
  service.get(`${BASE_URL}/project/resetQuestionnaire/${projectId}`);

export const fetchComplexityMode = (projectId) =>
  service.get(`${BASE_URL}/project/projectStatus/${projectId}`);

export const hideQuestion = (projectId, actualIndex) =>
  service.get(
    `${BASE_URL}/project/questionnaire/hideQuestion/${projectId}/${
      actualIndex + 1
    }`,
  );

export const postComplexityMode = async (projectId, data) => {
  const response = await service.post(
    `${BASE_URL}/project/projectStatus/${projectId}`,
    data,
  );
  return response;
};

export const getHeadcountReferenceData = async (projectId) => {
  const response = await service.get(
    `${BASE_URL}/project/financials/getHeadcountReferenceData/${projectId}`,
  );
  return response;
};

// TODO - 吴迪
// /api/v1/people/getProjectMember/null

// /api/v1/project/projectStatus/null

// /api/v1/project/accessibleModule/null

// /api/v1/project/dealComplexity/getQuesStatusAndSectionLevel/null
